export const checkValidDate = (date) => {
  const targetDate = new Date(date);
  const currentDate = new Date();
  return currentDate < targetDate;
};
